// TODO: tRPC seems to be inconsistent in the way it canonicalises unicode characters.
// On Safari, they tend to end up canonicalised, whereas they don't on other browsers.

import { SuperJSONResult, SuperJSONValue } from 'superjson/dist/types';
import superjson from 'superjson';

// This wraps superjson to control the way these characters are handled.
class URLEncodedTransformer {
  transformStrings<T = unknown>(inObject: T, transform: (string) => string): T {
    if (typeof inObject === 'string') {
      return transform(inObject) as T;
    }
    if (Array.isArray(inObject)) {
      return inObject.map((v) => this.transformStrings(v, transform)) as T;
    }
    if (typeof inObject === 'object' && inObject !== null) {
      return Object.fromEntries(
        Object.entries(inObject).map(([k, v]) => [k, this.transformStrings(v, transform)])
      ) as T;
    }
    return inObject;
  }

  serialize(inObject: SuperJSONValue): SuperJSONResult {
    const serialised = superjson.serialize(inObject);

    return {
      json: this.transformStrings(serialised.json, encodeURIComponent),
      meta: serialised.meta,
    };
  }
  deserialize<T = unknown>(payload: SuperJSONResult): T {
    const deserialised = {
      json: this.transformStrings(payload.json, decodeURIComponent),
      meta: payload.meta,
    };
    return superjson.deserialize<T>(deserialised);
  }
}

const urlEncodedTransformer = new URLEncodedTransformer();
export default urlEncodedTransformer;
